webpackJsonp([78027301358612],{

/***/ 154:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(4);
	
	var _gatsbyImage = __webpack_require__(21);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Layout = __webpack_require__(12);
	
	var _colors = __webpack_require__(10);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var style = /*#__PURE__*/(0, _reactEmotion.css)('text-align:center;padding-bottom:10%;color:', _colors2.default.primary, ';div{p{margin-top:2em;}}'); /* eslint-disable no-undef, react/prop-types */
	
	
	var startStyle = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:2em;');
	
	var logoStyle = /*#__PURE__*/(0, _reactEmotion.css)('height:50%;padding:0;margin-left:auto;margin-right:auto;');
	
	var outerImgWrapper = /*#__PURE__*/(0, _reactEmotion.css)('width:50%;margin-left:auto;margin-right:auto;margin-top:2em;');
	
	var vimeoWrapper = /*#__PURE__*/(0, _reactEmotion.css)('margin-top:1em;margin-bottom:1em;');
	
	var Teoksesta = function Teoksesta(_ref) {
	  var data = _ref.data;
	  var logo = data.logo,
	      kakarat = data.kakarat;
	
	  return _react2.default.createElement(
	    _Layout.Box,
	    null,
	    _react2.default.createElement(
	      _Layout.Box,
	      {
	        className: style,
	        width: [1, 1, 1 / 2],
	        m: ['3.5rem 0 0 0', '3.5rem 0 0 0', '3.5rem auto 0 auto'],
	        px: [3, 3, 0],
	        color: _colors2.default.secondary
	      },
	      _react2.default.createElement(
	        'div',
	        { className: startStyle },
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'kakarat',
	          sizes: kakarat.childImageSharp.sizes,
	          imgStyle: { objectFit: 'contain' }
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Kotona Tytti kokee olevansa n\xE4kym\xE4t\xF6n. Paetessaan taianomaiseen unimaailmaan Tytti kohtaa muuttuneen Owlan. Ennen niin herttainen kaupunki on nyt harmaa ja kolea. Tullissa kaikki jaetaan meihin ja toisiin, Merikoskenneidoista kaunein on kadonnut eik\xE4 Molloplaanallakaan raikaa en\xE4\xE4 Tervaporvarien p\xE4iv\xE4tanssit.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Kaupunkiin saapunut Apteekkari eliksiireineen on saanut Owlan aivan sekaisin. Yst\xE4vykset Tytti, Maija ja Franz tempautuvat el\xE4m\xE4ns\xE4 seikkailuun yritt\xE4ess\xE4\xE4n pelastaa Owlan ahneen Apteekkarin kynsist\xE4.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'L\xF6yt\xE4\xE4k\xF6 kolmikko Owlan kadonneen walkian? Mit\xE4 kummaa Apteekkari aikoo tehd\xE4 valtavalla kuumailmapallollaan? Enta\u0308 mita\u0308 tapahtuu, kun Tytti palaa unimaailmastaan kotiin? Onnistuuko perhe vihdoin kohtaamaan toisensa?'
	        ),
	        _react2.default.createElement(_gatsbyImage2.default, {
	          alt: 'logo',
	          sizes: logo.childImageSharp.sizes,
	          outerWrapperClassName: outerImgWrapper,
	          imgStyle: {
	            objectFit: 'contain'
	          }
	        }),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Elena Vuoksiolan k\xE4sikirjoittama Owla ja kadonnut walkia kutsuu koko perheen kohtaamisten, tanssin riemun ja juurevan kansanmusiikin \xE4\xE4relle. Owlassa sadun taika kietoutuu suomalaiseen kansanperinteeseen ja Oulun paikallishistoriaan. Yli 90 eri-ik\xE4ist\xE4 oululaista ammattitanssijaa ja kansantanssin harrastajaa yhdist\xE4v\xE4t voimansa t\xE4ss\xE4 kansantanssin suurproduktiossa.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Owla ja kadonnut walkia on itsen\xE4inen jatko-osa vuonna 2014 kantaesitetylle Owla \u2013 tanssiseikkailulle. Owla \u2013 tanssiseikkailu palkittiin Suomen Nuorisoseurojen ja Folklandian myo\u0308nta\u0308ma\u0308lla\u0308 Vuoden tanssiteko 2014 -tunnustuksella.'
	        )
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: vimeoWrapper },
	        _react2.default.createElement('iframe', {
	          src: 'https://player.vimeo.com/video/95659321?title=0&byline=0&portrait=0',
	          width: '100%',
	          height: '360',
	          frameBorder: '0',
	          title: 'Owla',
	          webkitallowfullscreen: true,
	          mozallowfullscreen: true,
	          allowFullScreen: true
	        })
	      )
	    )
	  );
	};
	
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = Teoksesta;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-teoksesta-js-7c6ca28d55949386f1fa.js